import { h, Component } from 'preact';

import { getRelativePageUrl, getMainPage, getValueForClientSize, isVideosPage } from 'utils/bolt';
import { filterUnusedPages } from 'utils/bolt/header';
import { useDynamicAssetFolder } from 'utils/assets';
import { sortObjectByOrder, accessNested, joinClasses } from 'utils/utils';
import Store from 'store/store';
import HTML from 'components/core/html/html';

import Socials from 'components/bolt/socials/socials';
import Link from 'components/bolt/link/link';
import s from 'components/bolt/header/headerExpanded.sss';
import * as webp from 'utils/bolt/webp';
export default class HeaderExpanded extends Component {

	constructor(props) {
		super(props);

		this.closeAndNavigate = this.closeAndNavigate.bind(this);
		this.getFallbackFormat = this.getFallbackFormat.bind(this);
		this.updateLinks(props);
		this.isSplitHeader = !!this.featuredLinks.length;

		this.updateLinks = this.updateLinks.bind(this);
	}

	componentDidMount() {
		Store.on('REFRESH_HEADER_LINKS', this.updateLinks);
	}
	componentWillUnmount() {
		Store.off('REFRESH_HEADER_LINKS', this.updateLinks);
	}

	updateLinks(props = this.props) {
		this.navItems = sortObjectByOrder(accessNested(props, 'appData.header.powsterHeader.nav'));
		this.filteredNavItems = filterUnusedPages(props, this.navItems);
		this.standardLinks = this.filteredNavItems.filter(item => item && item.linkType === 'primary');
		this.featuredLinks = this.navItems.filter(item => item && item.linkType === 'secondary');
	}

	trackNavLink(linkName, id) {
		Store.emit('TRACK_NAV_LINK_CLICK', linkName, id);
	}

	getFallbackFormat() {
		return accessNested(this.props, 'appData.header.alternativeImageFormat', 'png');
	}

	closeAndNavigate(id, e, linkName, queryString) {
		// TODO: Store.emit('CLOSE_AND_NAVIGATE', id, e);

		if (e && e.preventDefault) {
			e.preventDefault();
		}

		this.trackNavLink(linkName, id);

		Store.emit('CLOSE_NAV_MENU');
		const groupBookingsEnabled = accessNested(this.props, 'appData.pages.boltShowtimes.data.groupBookings.isEnabled', false);

		// gb-only hack to clear ?booknow and ?groupbookings on other header clicks
		if (groupBookingsEnabled && !queryString && typeof window !== undefined && window.location.search) {
			history.replaceState && history.replaceState(
				null, '', window.location.pathname
			);
		}
		//

		if (id.startsWith('@')) {
			Store.emit('OPEN_RESERVED_VARIABLE_LINK', id);
		}

		const page = accessNested(this.props, ['appData', 'pages', id]);
		if (!page) {
			return;
		}

		if (!page.section && !page.type && id !== 'boltHome') {
			Store.emit('CLOSE_ALL_OVERLAYS');
			Store.emit('SET_ACTIVE_PAGE', id);
			return;
		}

		if (page.type === 'showtimes') {
			if (this.props.isCalendarRemindMode) {
				Store.emit('SET_ACTIVE_PAGE', getMainPage());
				Store.emit('SHOW_CAL_REMIND');
			} else {
				Store.emit('SHOWTIMES_SHOW', undefined, queryString, id);
			}
		} else if (page.type === 'homeEnt') {
			Store.emit('HOMEENT_SHOW', undefined, undefined, id);
		} else if (page.type === 'pressKit') {
			Store.emit('PRESSKIT_SHOW', undefined, undefined, id);
		} else if (isVideosPage(id)) {
			Store.emit('OPEN_VIDEO_OVERLAY', id);
		} else {
			Store.emit('CLOSE_ALL_OVERLAYS');
			Store.emit('SET_ACTIVE_PAGE', id);
			Store.emit('CHANGE_ACTIVE_SECTION', id, { instant: true, mainPage: getMainPage() });
			if (page.type === 'stickAndScaleWidget') {
				Store.emit('EXPAND_WIDGET');
			}
		}
	}

	getLinkSizing(isLinkOut) {
		if (isLinkOut) {
			return null;
		}

		return this.isSplitHeader ? s.h4 : s.h3;
	}

	renderLink(element, isFeatured) {
		// const isInternalLink = /^bolt/.test(element.path);
		const page = accessNested(this.props, ['appData', 'pages', element.path]);
		const calendarEnabled = !!accessNested(this.props, 'appData.header.powsterHeader.calendars', null);
		const isInternalLink = !!page || element.path.startsWith('@');
		const sizing = this.getLinkSizing(!isInternalLink);

		const activePage = this.props.activePage || 'boltHome';
		const activeSection = this.props.headerData.activeSection || 'boltHome';
		let active = activePage === element.path || (activePage === 'boltHome' && activeSection === element.path);
		const baseCopy = accessNested(this.props, 'appData.copy.baseCopy', {});
		let content = baseCopy[element.name] || element.name || element.id;

		// - start  - groupBookings same page 2 header items active 'hack'
		const groupBookingsEnabled = accessNested(this.props, 'appData.pages.boltShowtimes.data.groupBookings.isEnabled', false);
		if (groupBookingsEnabled && activePage == element.path && element.path === 'boltShowtimes' && element?.queryString === '?groupbookings') {
			active = Store.get().groupBookingsShowtimes === true;
		}
		if (groupBookingsEnabled && activePage == element.path && element.path === 'boltShowtimes' && element?.queryString === '?booknow') {
			active = Store.get().groupBookingsShowtimes === false;
		}
		//- end -

		if (page?.ageRestricted && this.props.client?.ofAge === false) {
			return;
		}

		if (element.path === 'boltShowtimes' && this.props.isCalendarRemindMode) {
			if (!calendarEnabled) return;
			content = baseCopy.$MENU_CALENDAR_REMINDER || 'Reminder';
		}

		let attributes = {};
		if (!isInternalLink) {
			attributes.href = element.path;
			attributes.target = element.sameWindow ? '_self' : '_blank';
			attributes.rel = 'noopener noreferrer';
			attributes.onClick = () => this.trackNavLink(content);
		} else {
			attributes.href = getRelativePageUrl(element.path, '') || '#';
			// should probably use a button element instead of a link
			attributes.onClick = element.onClick || (e => this.closeAndNavigate(element.path, e, content, element.queryString));
		}

		const fontStyles = accessNested(this.props, 'appData.styling.fontVariables');
		const font = isFeatured ? fontStyles.navSecondaryLink : fontStyles.navPrimaryLink;

		return (
			<Link
				key={element.id || element.link || element.name}
				class={joinClasses(s.link, active && s.active, sizing, font)}
				ariaLabel={element.name}
				{...attributes}
			>
				<HTML class={s.content} content={content} markdown />
				<HTML class={s.hidden} content={content} aria-hidden markdown />
			</Link>
		);
	}

	renderRegionSelector() {
		const regionData = accessNested(this.props, 'appData.meta.region') || {};
		const regionSelectorCustomisation = accessNested(this.props, 'appData.header.powsterHeader.regionSelector.extraRegions', {});
		const currentRegionNameOverride = regionSelectorCustomisation[regionData.slug] || {};
		let currentRegionLabel = currentRegionNameOverride.label || regionData.slug;
		const useLanguage = this.props?.appData?.header?.powsterHeader?.regionSelector?.useLanguage;
		if (useLanguage) {
			currentRegionLabel = currentRegionNameOverride.label || regionData.languageFull || regionData.language;
		}
		const accessibilityCopy = accessNested(this.props.appData, 'copy.accessibilityCopy');
		return (
			<button
				class={s.regionSelectorButton}
				onClick={this.props.regionSelectorClick}
				key="regionSelectorButton"
				ariaLabel={accessibilityCopy.$REGION_SELECTOR_BTN_ARIA}
			>
				<div class={s.icon} />
				<span class={s.name}>{currentRegionLabel}</span>
			</button>
		);
	}

	renderSocial() {
		const socials = accessNested(this.props, 'appData.header.powsterHeader.follow');
		if (!socials) {
			return;
		}
		return (
			<Socials
				class={s.socials}
				socials={socials}
				navOpen={this.props.navOpen}
				fill={accessNested(this.props, 'appData.styling.variables.headerNavSocialIcon', '#fff')}
				key="socials"
			/>
		);
	}

	getTTSize(tt) {
		if (tt?.titleTreatmentSize?.desktop || tt?.titleTreatmentSize?.tablet || tt?.titleTreatmentSize?.mobile) {
			return getValueForClientSize(tt.titleTreatmentSize);
		}
	}

	render({ navOpen, showRegionSelector }) {
		const store = Store.get();
		let ttStyle;
		let { pushDown, cookieBannerOpen, height: cookieHeight } = store.cookies || {};
		const evidonMode = accessNested(store, 'evidon.bannerOpen');
		const cookieMode = evidonMode || (pushDown && cookieBannerOpen);
		const sonyHeaderEnabled = accessNested(this.props, 'appData.options.sonyFeatures.sonyHeader', false);
		const evidonMobile = evidonMode && !accessNested(store, 'client.isDesktopSize', false);
		const copy = accessNested(this.props, 'appData.copy');
		const tt = accessNested(this.props, 'appData.header.powsterHeader.tt', null);
		const ttSize = this.getTTSize(tt);
		const isSplitHeader = this.isSplitHeader;
		const deviceSize = accessNested(this.props, 'client.deviceSize');
		const fallbackFormat = this.getFallbackFormat();

		if (evidonMode) {
			cookieHeight = accessNested(store, 'evidon.height');
		}

		if (ttSize) {
			ttStyle = {
				width: '100%',
				height: '100%',
				maxWidth: ttSize.maxWidth,
				maxHeight: ttSize.maxHeight
			};
		}

		let links = [
			<div class={s.standard} key="standard">
				{tt && (
					<webp.Picture
						style={ttStyle}
						class={s.tt}
						src={useDynamicAssetFolder(getValueForClientSize(tt))}
						alt={copy.accessibilityCopy[tt.alt] || tt.alt}
						fallbackFormat={fallbackFormat}
					/>
				)}

				{this.standardLinks.map(link => this.renderLink(link, false))}
			</div>
		];

		if (isSplitHeader) {
			links.push(
				<div class={s.separator} key="separator" />,
				<div class={s.featured} key="featured">
					{this.featuredLinks.map(link => this.renderLink(link, true))}
				</div>
			);
		}

		let paddingTop = sonyHeaderEnabled ? 34 : 0;
		if (cookieMode) {
			paddingTop += cookieHeight;
		}

		const totalLinks = this.standardLinks.length + this.featuredLinks.length;

		let isDesktop = true;
		if (deviceSize !== 'desktop' && deviceSize !== 'largeDesktop') {
			isDesktop = false;
		}

		return (
			<div
				class={joinClasses({
					s,
					container: true,
					open: navOpen,
					splitHeader: isSplitHeader,
					hasRegionSelector: showRegionSelector,
					hasManyLinks: totalLinks >= 8
				})}
				style={(navOpen && paddingTop) && { top: `${paddingTop}px`, height: `calc(var(--windowHeight) - ${paddingTop}px)` }}
				body-scroll-lock-ignore={evidonMobile}
			>
				<div class={s.linksContainer} style={{ height: isSplitHeader && !isDesktop ? 'auto' : evidonMobile ? 'var(--windowHeight)' : '100%' }}>
					<div class={s.links} role="navigation">
						{links}
						{this.renderSocial()}
					</div>
					{this.renderRegionSelector()}
				</div>
			</div>
		);
	}

}
